import { createSlice } from '@reduxjs/toolkit';
import { LOCALE } from 'constants/common';

const appSlice = createSlice({
  name: 'app',
  initialState: {
    currentLocale: LOCALE.VIETNAMESE,
    localeCode: null,
  },
  reducers: {
    doSwitchLocale(state, action) {
      state.currentLocale = action.payload;
    },
    doChangeLocaleCode(state, action) {
      state.localeCode = action.payload;
    },
  },
});

const { actions, reducer } = appSlice;
export const { doSwitchLocale, doChangeLocaleCode } = actions;
export default reducer;
